import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CookiesDataService } from '@nibtravel/shared/data-access/cookies';
import { AlertType } from '@nibtravel/shared/ui/components/alert';
import { Documents } from '@nibtravel/shared/util/constants';
import { Alert } from '@nibtravel/shared/util/e2e';

@Component({
  selector: 'nibtravel-cookies-alert',
  templateUrl: './cookies-alert.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookiesAlertComponent implements OnInit {
  alertType = AlertType.INFO;
  isAccepted = false;
  cookieName = 'CookieConsent';
  cookieValue = '1';
  cookiePolicyLink = Documents.GroupPrivacyPolicy;
  e2eId = Alert;
  constructor(private cookieService: CookiesDataService) {}

  ngOnInit(): void {
    const t = this.cookieService.get(this.cookieName);
    this.isAccepted = t === this.cookieValue;
  }

  onAcceptOrClose(): void {
    this.isAccepted = true;
    this.cookieService.set(this.cookieName, this.cookieValue);
  }
}
